import { hasActiveFilters } from '../../components/FilterBar';
import type { FilterBarFiltersProps } from '../../components/FilterBar';

interface CollectionEmptyContentParams {
  emptyContent?: string;
  searchValue?: string;
  filterProps?: Pick<FilterBarFiltersProps, 'value' | 'filters'>;
  loading?: boolean;
}

export const getCollectionEmptyContent = ({
  emptyContent,
  searchValue,
  filterProps,
  loading,
}: CollectionEmptyContentParams) => {
  if (loading) return '';
  const search = searchValue?.trim();
  if (search) return `No results match "${search}".`;
  if (filterProps && hasActiveFilters(filterProps.value, filterProps.filters)) {
    return 'No results match the selected filters.';
  }
  return emptyContent;
};
